var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1456 22C13.9016 22 14.4393 21.3487 14.8257 20.3406L21.7043 2.37306C21.8925 1.89018 22 1.45972 22 1.10251C22 0.420018 21.58 -3.05176e-05 20.8978 -3.05176e-05C20.5383 -3.05176e-05 20.1082 0.104813 19.6243 0.294002L1.56256 7.21434C0.682153 7.55038 0 8.08569 0 8.85252C0 9.81863 0.735931 10.1442 1.74403 10.4487L8.02062 11.5632C8.69268 11.7732 9.07239 11.752 9.52267 11.332L20.4341 1.1761C20.5719 1.05008 20.7298 1.07125 20.834 1.16568C20.9381 1.27052 20.9482 1.42813 20.8239 1.56456L10.7089 12.5185C10.2989 12.9493 10.2687 13.3062 10.4669 14.0098L11.5293 20.1622C11.8451 21.2227 12.1711 22 13.1456 22Z",
    fill: "#0F7BBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.fd246433c959481f455323564c12f5a1.svg";
export { ForwardRef as ReactComponent };